module.exports = "<select :name=\"fieldName\" class=\"form-control\" :value=\"value\" @change=\"onChange($event)\">\r\n    <option v-for=\"o in options\" :value=\"o.value\">{{o.name}}</option>\r\n</select>"


//////////////////
// WEBPACK FOOTER
// /Users/mac/001.code/xbigger-web/xbigger/fnjinew/build-v2/node_modules/text-loader!./index2021-cooperate/component/enum-select.html
// module id = 232
// module chunks = 0